import AssignmentSettingsEditor from 'components/CreateAssignment/AssignmentSettingsEditor';

export default AssignmentSettingsEditor;
